export const promptEnum = {
    'CLASSIQUE': 'CLASSIQUE',
    'TECHNIQUE': 'TECHNIQUE'
};